import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { typePrefix } from '@redux/map/action'
import { STATUS_CODE } from '@utils/Const'
import mapRequest from '@apis/map'

const initialState = {
  milestones: {},
  stages: [],
  isLoading: false,
  isFinishRoadMap: false,
  status: false,
  demo_topic_id: '',
  isShowUpgradeModal: false,
  entryPointShowUpgradeModal: '',
  isCompleteFirstTask: false,
}

export const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    updateStatusMap: (state: any, action: any) => {
      state.isFinishRoadMap = action.payload
    },
    updateIsShowUpgradeModal: (state: any, action) => {
      state.isShowUpgradeModal = action.payload
    },
    updateEntryPointShowUpgradeModal: (state: any, action) => {
      state.entryPointShowUpgradeModal = action.payload
    },
    updateIsCompleteFirstTask: (state: any, action) => {
      state.isCompleteFirstTask = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(getMapStatus.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(getMapStatus.fulfilled, (state: any, action: any) => {
      if (action.payload.status === STATUS_CODE.SUCCESS) {
        state.isFinishRoadMap = action.payload?.data?.is_finish_roadmap
      }
      state.isLoading = false
    })
    builder.addCase(getMapStatus.rejected, (state: any, action: any) => {
      state.data = []
      state.isLoading = false
    })
  },
})

export const getMapStatus = createAsyncThunk(
  typePrefix.MAP_STATUS,
  async () => {
    const response = await mapRequest.getMapStatus()
    return response?.data
  },
)

export const {
  updateStatusMap,
  updateIsShowUpgradeModal,
  updateEntryPointShowUpgradeModal,
  updateIsCompleteFirstTask,
} = mapSlice.actions

export default mapSlice.reducer
